var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("section", { staticClass: "panel", attrs: { id: "monthView" } }, [
    _c("div", { staticClass: "month-toolbar" }, [
      _c("div", [
        _c(
          "h2",
          { staticStyle: { margin: "0", "font-size": "18px" } },
          [
            _c(
              "font",
              {
                staticStyle: { "vertical-align": "inherit" },
                attrs: { dir: "auto" },
              },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [_vm._v(_vm._s(_vm.$t("title.monthlyoverview")))]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "small",
          { staticStyle: { color: "var(--muted)" } },
          [
            _c(
              "font",
              {
                staticStyle: { "vertical-align": "inherit" },
                attrs: { dir: "auto" },
              },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [_vm._v(_vm._s(_vm.$t("title.monthlyoverviewdesc")))]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "month-controls" }, [
        _c(
          "label",
          { staticClass: "field-inline" },
          [
            _c(
              "font",
              {
                staticStyle: { "vertical-align": "inherit" },
                attrs: { dir: "auto" },
              },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("supervisors")) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("selectoptions", {
              staticClass: "wd-200",
              attrs: {
                url: "/applicationuser/list/attendantall?active=true",
                emptyname: "Select",
              },
              model: {
                value: _vm.attendantId,
                callback: function ($$v) {
                  _vm.attendantId = $$v
                },
                expression: "attendantId",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "field-inline" },
          [
            _c(
              "font",
              {
                staticStyle: { "vertical-align": "inherit" },
                attrs: { dir: "auto" },
              },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("month")) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.monthyear,
                  expression: "monthyear",
                },
              ],
              attrs: { id: "monthPicker", type: "month", value: "2026-06" },
              domProps: { value: _vm.monthyear },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.monthyear = $event.target.value
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "month-summary" }, [
      _c("div", { staticClass: "metric" }, [
        _c(
          "strong",
          { attrs: { id: "monthContract" } },
          [
            _c(
              "font",
              {
                staticStyle: { "vertical-align": "inherit" },
                attrs: { dir: "auto" },
              },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [_vm._v(_vm._s(_vm.result.totalHours))]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          [
            _c(
              "font",
              {
                staticStyle: { "vertical-align": "inherit" },
                attrs: { dir: "auto" },
              },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [_vm._v(_vm._s(_vm.$t("contracthourmonth")))]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "metric" }, [
        _c(
          "strong",
          { attrs: { id: "monthPlanned" } },
          [
            _c(
              "font",
              {
                staticStyle: { "vertical-align": "inherit" },
                attrs: { dir: "auto" },
              },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [_vm._v(_vm._s(_vm.result.scheduleHours))]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          [
            _c(
              "font",
              {
                staticStyle: { "vertical-align": "inherit" },
                attrs: { dir: "auto" },
              },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [_vm._v(_vm._s(_vm.$t("scheduledhour")))]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "metric" }, [
        _c(
          "strong",
          { attrs: { id: "monthDifference" } },
          [
            _c(
              "font",
              {
                staticStyle: { "vertical-align": "inherit" },
                attrs: { dir: "auto" },
              },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [_vm._v(_vm._s(_vm.result.difference))]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          [
            _c(
              "font",
              {
                staticStyle: { "vertical-align": "inherit" },
                attrs: { dir: "auto" },
              },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [_vm._v(_vm._s(_vm.$t("difference")))]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "metric" }, [
        _c(
          "strong",
          { attrs: { id: "monthWarnings" } },
          [
            _c(
              "font",
              {
                staticStyle: { "vertical-align": "inherit" },
                attrs: { dir: "auto" },
              },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [_vm._v("0")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          [
            _c(
              "font",
              {
                staticStyle: { "vertical-align": "inherit" },
                attrs: { dir: "auto" },
              },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [_vm._v(_vm._s(_vm.$t("warning")))]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "calendar-head" },
      _vm._l(_vm.weekdays, function (item) {
        return _c(
          "div",
          [
            _c(
              "font",
              {
                staticStyle: { "vertical-align": "inherit" },
                attrs: { dir: "auto" },
              },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [_vm._v(_vm._s(item))]
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.initialized
      ? _c(
          "div",
          { staticClass: "calendar-grid", attrs: { id: "calendarGrid" } },
          [
            _vm._l(_vm.list, function (week) {
              return _vm._l(week, function (day) {
                return _c(
                  "div",
                  {
                    staticClass: "calendar-day",
                    class: _vm.getdaycss(day.date),
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "day-number" },
                      [
                        _c(
                          "font",
                          {
                            staticStyle: { "vertical-align": "inherit" },
                            attrs: { dir: "auto" },
                          },
                          [
                            _c(
                              "font",
                              {
                                staticStyle: { "vertical-align": "inherit" },
                                attrs: { dir: "auto" },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm._f("dayOfMonth")(day.date))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(day.activities, function (activity, index) {
                          return _c(
                            "button",
                            {
                              staticClass: "month-event",
                              attrs: { title: "BONT Academie 08:30�16:00" },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(activity.title)
                              ),
                              _c("small", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("time")(activity.startDateTime)
                                  ) +
                                    " - " +
                                    _vm._s(_vm._f("time")(activity.endDateTime))
                                ),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                )
              })
            }),
          ],
          2
        )
      : _c("div", [_c("spinner")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }